/**
 * Tangerine AI Color Generator
 * Uses predefined color palettes from design team
 */

// Design-approved color palettes
const COLOR_PALETTES = {
  // Tangerine IA - Default Purple Theme
  '#BC3EBC': {
    primary: '#BC3EBC',
    dark: '#741571',
    light: '#F0C0F0',
    lighter: '#FFE8FF',
    alpha: 'rgba(188, 62, 188, 0.15)',
    gradient1: '#BC3EBC',
    gradient2: '#741571',
  },

  '#FF5322': {
    primary: '#BC3EBC',
    dark: '#741571',
    light: '#F0C0F0',
    lighter: '#FFE8FF',
    alpha: 'rgba(188, 62, 188, 0.15)',
    gradient1: '#BC3EBC',
    gradient2: '#741571',
  },

  // Sumun - Teal/Cyan Theme
  '#007F9E': {
    primary: '#007F9E',
    dark: '#103C4C',
    light: '#67CBE7',
    lighter: '#CAF5FF',
    alpha: 'rgba(0, 127, 158, 0.15)',
    gradient1: '#e9501d',
    gradient2: '#103c4c',
  },

  // Edelvives - Orange Theme
  '#ED7011': {
    primary: '#ED7011',
    dark: '#B94F00',
    light: '#FFE0C9',
    lighter: '#FFE0C9',
    alpha: 'rgba(237, 112, 17, 0.10)',
    gradient1: '#ED7011',
    gradient2: '#ED7011',
  },
};

/**
 * Initialize Tangerine AI colors using design-approved palettes
 */
export function initTangerineAIColors() {
  const root = document.documentElement;
  const computed = getComputedStyle(root);

  // Get primary color from platform or use default
  const primary = computed.getPropertyValue('--color-first').trim().toUpperCase();

  // Look up the palette (normalize to uppercase for consistency)
  const palette = COLOR_PALETTES[primary.toUpperCase()] || COLOR_PALETTES['#BC3EBC'];

  // Apply predefined color variants from design map
  root.style.setProperty('--color-tangerine-ai', palette.primary);
  root.style.setProperty('--color-tangerine-ai-dark', palette.dark);
  root.style.setProperty('--color-tangerine-ai-light', palette.light);
  root.style.setProperty('--color-tangerine-ai-lighter', palette.lighter);
  root.style.setProperty('--color-tangerine-ai-alpha', palette.alpha);

  // Handle gradients from platform or create from palette
  const gradient1 = palette.gradient1;
  const gradient2 = palette.gradient2;

  root.style.setProperty('--color-tangerine-ai-gradient', `linear-gradient(111.12deg, ${gradient1} 0.31%, ${gradient2} 100%)`);
  root.style.setProperty('--color-tangerine-ai-gradient-reverse', `linear-gradient(111.12deg, ${gradient2} 0.31%, ${gradient1} 100%)`);
}

/**
 * Initialize on DOM ready
 * This ensures CSS variables are available before generation
 */
if (typeof window !== 'undefined') {
  if (document.readyState === 'complete') {
    initTangerineAIColors();
  } else {
    window.addEventListener('load', initTangerineAIColors);
  }
}

// Export for manual initialization if needed
export default {
  initTangerineAIColors,
};
